import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  isLoading: false,
  printers: [],
};

export const fetchPrinters = createAsyncThunk(
  "fetchPrinters/printer",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("admin/printers");
      return response.data.data;
    } catch (error) {
      if (enqueueSnackbar) {
        enqueueSnackbar(error?.message || "Failed to load printers", {
          variant: "error",
        });
      }
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createPrinter = createAsyncThunk(
  "createPrinter/printer",
  async ({ data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post("admin/printers", data);
      enqueueSnackbar("Printer created successfully", { variant: "success" });
      return response.data.data;
    } catch (error) {
      enqueueSnackbar(error?.message || "Failed to create printer", {
        variant: "error",
      });
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updatePrinter = createAsyncThunk(
  "updatePrinter/printer",
  async ({ id, data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`admin/printers/${id}`, data);
      enqueueSnackbar("Printer updated successfully", { variant: "success" });
      return response.data.data;
    } catch (error) {
      enqueueSnackbar(error?.message || "Failed to update printer", {
        variant: "error",
      });
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const deletePrinter = createAsyncThunk(
  "deletePrinter/printer",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`admin/printers/${id}`);
      enqueueSnackbar("Printer deleted successfully", { variant: "success" });
      return { id };
    } catch (error) {
      enqueueSnackbar(error?.message || "Failed to delete printer", {
        variant: "error",
      });
      return thunkApi.rejectWithValue(error);
    }
  }
);

const printerSlice = createSlice({
  name: "printer",
  initialState,
  extraReducers: (builder) => {
    // Fetch printers
    builder.addCase(fetchPrinters.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPrinters.fulfilled, (state, action) => {
      state.isLoading = false;
      state.printers = action.payload;
    });
    builder.addCase(fetchPrinters.rejected, (state) => {
      state.isLoading = false;
    });

    // Create printer
    builder.addCase(createPrinter.fulfilled, (state, action) => {
      state.printers.push(action.payload);
      // Re-sort by sort_order
      state.printers.sort((a, b) => a.sort_order - b.sort_order);
    });

    // Update printer
    builder.addCase(updatePrinter.fulfilled, (state, action) => {
      const idx = state.printers.findIndex((p) => p.id === action.payload.id);
      if (idx !== -1) {
        state.printers[idx] = action.payload;
      }
    });

    // Delete printer
    builder.addCase(deletePrinter.fulfilled, (state, action) => {
      state.printers = state.printers.filter(
        (p) => p.id !== action.payload.id
      );
      // Re-sort after server resequences
      state.printers.sort((a, b) => a.sort_order - b.sort_order);
    });
  },
});

export default printerSlice.reducer;
